module.exports = __webpack_public_path__ + "static/media/vispan.aa2890ac.jpg";